<template>
<div :class="$style['agent-select-product-dialog']">
    <el-dialog :visible="dialogVisible" :title="dialogTitle" @close="cancel">
        <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" :class="$style['table-data-label']" ref="table">
            <wt-table :list="tableData" :labels="tableLabels" >
                 <el-table-column slot="before" label="" width="50">
                    <template  slot-scope="scope">
                        <el-radio v-model="selectId" :label="scope.row.productCode" :class="$style['meal-list-radio']" @change="selectMealRow(scope.row)"></el-radio>
                    </template>
                </el-table-column>
            </wt-table>
        </wt-paged-table>
        <div class="button-div">
          <el-button type="primary" @click="submit">选择</el-button>
          <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
    </el-dialog>
</div>
</template>
<script>
import { defaultPackageLabels } from 'cps/lab-order/pt-lab-order-form/agent-product-options.js'
export default {
  name: 'default-package-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: '选择商品'
    },
    pageSize: {
      type: Number,
      default: 8
    },
    agentId: {
      type: String,
      default: ''
    },
    // 传进的商品
    productId: {
      type: String,
      default: ''
    },
    // 传进的商品对象
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableData: [],
      tableLabels: defaultPackageLabels,
      selectId: this.productId ? this.productId : '',
      page: 0,
      select_row: this.data.productCode ? this.data : {}
    }
  },
  watch: {
    agentId (val) {
      this.getTableData(0)
    },
    data (val) {
      this.select_row = val.productCode ? val : {}
    },
    productId (val) {
      this.selectId = val || ''
    }
  },
  methods: {
    selectMealRow (data) {
      this.select_row = data
    },
    submit () {
      this.$emit('selectData', this.select_row)
    },
    cancel () {
      this.$emit('close')
    },
    getTableData (page, next) {
      this.page = page
      let data = {
        'pageableParam': {
          'page': page,
          'size': this.pageSize
        }
      }
      if (this.agentId) {
        data.organizationId = this.agentId
      }
      this.$store.dispatch('getAdultProductByAgentId', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        this.tableData.forEach((item, index) => {
          if (item.productCode === this.productId) {
            this.selectId = item.productCode
          }
        })
      }).catch(err => {
        this.$message.error(err || '获取商品列表失败')
        this.$refs.table.showReTry()
      })
    }
  }
}
</script>
<style module lang="less">
@import "~less/var";
.agent-select-product-dialog{
    :global
    .el-pagination{
        justify-content: flex-start!important;
    }
     :global
    .el-radio__label{
        display: none;
    }
    :global
    .el-radio__inner{
        border:1px solid @mainColor;
        border-radius:50%
    }
}
</style>
